import { GridCellProps } from "@progress/kendo-react-grid";
import { useContext } from "react";
import useSearchCarriers from "ticketing/hooks/useSearchCarriers";
import { TRefData } from "../types";
import { BulkImportContext } from "../util";
import { DropDownListCell } from "./DropDownListCell";

export const CarrierCell = (props: GridCellProps) => {
  const { fieldConfig, refData: allRefData } = useContext(BulkImportContext);
  const { field } = props;
  /* eslint-disable no-unused-vars */
  const [search, searchResults, loading, , clear] = useSearchCarriers();
  /* eslint-enable no-unused-vars */
  const carrierFieldConfig = fieldConfig?.find(f => f.name === field);
  const lookupName = carrierFieldConfig?.lookupName!;

  const getData = () => {
    return searchResults?.length ? searchResults : (allRefData?.[lookupName] as TRefData[]);
  };

  if (!carrierFieldConfig) {
    return <td></td>;
  }

  return (
    <DropDownListCell
      {...props}
      data={getData()}
      fieldConfig={carrierFieldConfig}
      loading={loading}
      onSearch={search}
      onDone={() => clear()}
    />
  );
};
